import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleQuote = ({
    previousTypename,
    quote,
    credit,
    parent
}) => {
    if (!quote) { return null; }

    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className={`px-10 sm:px-5 md:px-10 ${previousTypename === 'ModuleText' ? ' md:-mt-70' : ''} `}>
                    <div className='w-full sm:w-10/12 md:w-9/12 sm:ml-w-2/12 md:ml-w-3/12 '>

                        <div className='mb-20 md:mb-30'>
                            <svg
                                style={{ width: '70px', height: '54px' }}
                                viewBox='0 0 70 54'
                                xmlns='http://www.w3.org/2000/svg'>
                                <path
                                    d='M28.6164 0C9.68553 1.55556 0 11.7778 0 29.7778V54H29.717V26.2222H17.6101C17.6101 17.5556 20.6918 13.5556 28.6164 11.7778V0ZM68.8994 0C49.9686 1.55556 40.283 11.7778 40.283 29.7778V54H70V26.2222H57.8931C57.8931 17.5556 60.9748 13.5556 68.8994 11.7778V0Z'
                                    fill='#FC5200' />
                            </svg>
                        </div>
                        <blockquote className='type-style-3'>
                            {quote}
                            {credit && (
                                <span className='type-style-8 block mt-20'>{credit}</span>
                            )}
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleQuote.propTypes = {
    previousTypename: PropTypes.string,
    quote: PropTypes.string.isRequired,
    credit: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleQuote;
